import { render, staticRenderFns } from "./TermsAffiliates.vue?vue&type=template&id=3d64d9e3&scoped=true"
import script from "./TermsAffiliates.vue?vue&type=script&lang=js"
export * from "./TermsAffiliates.vue?vue&type=script&lang=js"
import style0 from "./TermsAffiliates.vue?vue&type=style&index=0&id=3d64d9e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64d9e3",
  null
  
)

export default component.exports